// extracted by mini-css-extract-plugin
export default {"root":"LicenceActions_root__eU7jZ","action":"LicenceActions_action__adaLd"};